<div 
  class="so-option-button"
  [class.selected]="selected()"
  [class.disabled]="effectiveDisabled()"
  [attr.tabindex]="effectiveDisabled() ? -1 : 0"
  [attr.aria-disabled]="effectiveDisabled()"
  [attr.aria-selected]="selected()"
  role="option"
  (click)="onClick()"
  (keydown)="onKeydown($event)">

  <!-- Icon section -->
  @if (config().icon) {
    <div class="so-option-button__icon-wrapper">
      @if (config().iconType === 'svg') {
        <div 
          class="so-option-button__icon-container"
          [style.width.px]="iconContainerSize()"
          [style.height.px]="iconContainerSize()"
          [style.border-radius.px]="iconBorderRadius()"
          [style.background-color]="effectiveDisabled() ? 'rgba(148, 163, 184, 0.1)' : iconBgColor()">
          <img 
            [src]="config().icon" 
            [alt]="config().title"
            class="so-option-button__svg-icon"
            [style.width.px]="iconSize()"
            [style.height.px]="iconSize()" />
        </div>
      } @else {
        <div 
          class="so-option-button__icon-container"
          [style.width.px]="iconContainerSize()"
          [style.height.px]="iconContainerSize()"
          [style.border-radius.px]="iconBorderRadius()"
          [style.background-color]="effectiveDisabled() ? 'rgba(148, 163, 184, 0.1)' : iconBgColor()">
          <span 
            class="material-icons so-option-button__icon"
            [style.font-size.px]="iconSize()"
            [style.color]="effectiveDisabled() ? 'var(--so-gray-thick, #94a3b8)' : effectiveIconColor()">
            {{ config().icon }}
          </span>
        </div>
      }
    </div>
  }

  <!-- Content section -->
  <div class="so-option-button__content">
    <span class="so-option-button__title">
      {{ config().title }}
    </span>
    @if (config().description) {
      <span class="so-option-button__description">
        {{ config().description }}
      </span>
    }
  </div>

  <!-- Checkmark section -->
  @if (showCheckmark() && selected()) {
    <div class="so-option-button__checkmark">
      <span class="material-icons">check_circle</span>
    </div>
  }
</div>
